var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import NxAccordion from '../NxAccordion';
import { propTypes } from './types';
import useToggle from '../../../util/useToggle';
export default function NxStatefulAccordion(_a) {
    var defaultOpen = _a.defaultOpen, onToggle = _a.onToggle, otherProps = __rest(_a, ["defaultOpen", "onToggle"]);
    var _b = useToggle(defaultOpen || false), open = _b[0], toggleOpen = _b[1];
    function openHandler() {
        var newStatus = toggleOpen();
        if (onToggle) {
            onToggle(newStatus);
        }
    }
    return React.createElement(NxAccordion, __assign({ open: open, onToggle: openHandler }, otherProps));
}
NxStatefulAccordion.propTypes = propTypes;
//# sourceMappingURL=NxStatefulAccordion.js.map